<template>
  <div class="p-5 row" style="background: #da595a; color: #ffffff">
    <div
      class="col-12 mb-5 text-title"
      style="text-align: center; font-weight: 700"
    >
      สถิติการเข้าใช้งาน
    </div>
    <div
      class="col-12"
      style="
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        flex-wrap: wrap;
      "
    >
      <div>
        <p class="text-app text-header">
          {{ abbreviateNumber(sizeStatistic ? sizeStatistic.userAllSize : 0) }}
        </p>
        <p class="text-des">ผู้ใช้งาน</p>
      </div>
      <div>
        <p class="text-app text-header">
          {{ abbreviateNumber(sizeStatistic ? sizeStatistic.courseSize : 0) }}
        </p>
        <p class="text-des">หลักสูตรทั่วไป</p>
      </div>
      <div>
        <p class="text-app text-header">
          {{ abbreviateNumber(sizeStatistic ? sizeStatistic.syllabusSize : 0) }}
        </p>
        <p class="text-des">หลักสูตรตามกฎหมาย</p>
      </div>
      <div>
        <p class="text-app text-header">
          {{
            abbreviateNumber(sizeStatistic ? sizeStatistic.courseDoneSize : 0)
          }}
        </p>
        <p class="text-des">จบหลักสูตรทั่วไป</p>
      </div>
      <div>
        <p class="text-app text-header">
          <!-- sizeStatistic.syllabusDoneSize -->
          {{
            abbreviateNumber(sizeStatistic ? sizeStatistic.syllabusDoneSize : 0)
          }}
        </p>
        <p class="text-des">จบหลักสูตรตามกฎหมาย</p>
      </div>
      <div>
        <p class="text-app text-header">
          {{
            abbreviateNumber(
              sizeStatistic
                ? sizeStatistic.courseCerApproveSize +
                    sizeStatistic.syllabusApproveCerSize
                : 0
            )
          }}
        </p>
        <p class="text-des">ได้ใบรับรอง</p>
      </div>
    </div>
  </div>
  <div class="p-5" style="background: #ffffff">
    <div class="p-5 container my-10">
      <div class="text-center">
        <b
          class="text-header"
          style="font-weight: 700; color: #323563; padding-top: 5vh"
          >หลักสูตรตามกฎหมาย</b
        >
        <p style="font-size: 18px; color: #ababab">
          หลักสูตรนี้เหมาะสำหรับคณะทำงานด้านเทคนิค เจ้าหน้าที่ปกครองส่วนท้องถิ่น
          วิศวกร ผู้พัฒนาโครงการ ผู้บริหาร/เจ้าของกิจการ
          ที่สนใจและต้องมีการทดสอบ
          เพื่อขอรับใบรับรองเพื่อแต่งตั้งเป็นผู้รับผิดชอบด้านพลังงาน ทั้งนี้
          การแต่งตั้งเป็นผู้รับผิดชอบด้านพลังงานให้เป็นไปตามพระราชบัญญัติการส่งเสริมการอนุรักษ์พลังงาน
          พ.ศ.2535 (แก้ไขเพิ่มเติม พ.ศ.2550) และกฎกระทรวง กำหนดคุณสมบัติ หน้าที่
          และจำนวนของผู้รับผิดชอบด้านพลังงาน พ.ศ. 2552
        </p>
      </div>
      <div class="container mb-5">
        <div class="row">
          <div
            v-for="(item, index) in listSyllabuses"
            :key="index"
            class="col-12 col-md-6"
          >
            <div class="card">
              <div class="card-body">
                <div style="width: 100%; text-align: left" class="box-item">
                  <img
                    :src="imageUrl + item.thumbnailsPath"
                    @error="setAltImg"
                    alt=""
                    class="w-100"
                    style="border-radius: 10px"
                  />
                  <div class="my-5 p-5">
                    <p
                      class="text-title"
                      style="font-weight: 400; color: #323563"
                    >
                      {{ item.name }}
                    </p>

                    <p
                      class="text-category"
                      style="font-weight: 400; color: #ababab"
                    >
                      {{ item.description }}
                    </p>
                    <div style="display: flex; justify-content: center">
                      <button
                        v-if="item.register == false"
                        type="button"
                        @click="
                          registerSyllabus(item.id, item.register, 'false')
                        "
                        class="btn btn-register"
                      >
                        ลงทะเบียนเพื่อเรียนหลักสูตรนี้
                      </button>
                      <button
                        v-else
                        type="button"
                        @click="
                          registerSyllabus(item.id, item.register, 'true')
                        "
                        class="btn btn-register2"
                      >
                        เข้าสู่หลักสูตร
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- course -->
  <div class="p-5" style="background: #ffffff">
    <div class="container text-center my-10">
      <b class="text-header" style="font-weight: 700; color: #323563"
        >หลักสูตรทั่วไป</b
      >
      <p class="text-des" style="color: #ababab">
        หลักสูตรทั่วไปนี้สำหรับผู้ที่สนใจเกี่ยวกับความรู้ด้านพลังงาน เช่น
        ประชาชนทั่วไป นักเรียนนักศึกษา คณะทำงานด้านเทคนิค <br />
        เจ้าหน้าที่ปกครองส่วนท้องถิ่นวิศวกร ผู้พัฒนาโครงการ
      </p>
    </div>
    <div
      class="container mb-5 my-10"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div class="text-section" style="font-weight: 700; color: #323563">
        หลักสูตรแนะนำ
      </div>
      <div>
        <router-link to="/course/voluntary" class="btn link"
          >ดูทั้งหมด
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M17.92 12.12C17.8724 11.9973 17.801 11.8851 17.71 11.79L12.71 6.79C12.6168 6.69676 12.5061 6.6228 12.3842 6.57234C12.2624 6.52188 12.1319 6.49591 12 6.49591C11.7337 6.49591 11.4783 6.6017 11.29 6.79C11.1968 6.88324 11.1228 6.99393 11.0723 7.11575C11.0219 7.23758 10.9959 7.36814 10.9959 7.5C10.9959 7.7663 11.1017 8.0217 11.29 8.21L14.59 11.5H7C6.73478 11.5 6.48043 11.6054 6.29289 11.7929C6.10536 11.9804 6 12.2348 6 12.5C6 12.7652 6.10536 13.0196 6.29289 13.2071C6.48043 13.3946 6.73478 13.5 7 13.5H14.59L11.29 16.79C11.1963 16.883 11.1219 16.9936 11.0711 17.1154C11.0203 17.2373 10.9942 17.368 10.9942 17.5C10.9942 17.632 11.0203 17.7627 11.0711 17.8846C11.1219 18.0064 11.1963 18.117 11.29 18.21C11.383 18.3037 11.4936 18.3781 11.6154 18.4289C11.7373 18.4797 11.868 18.5058 12 18.5058C12.132 18.5058 12.2627 18.4797 12.3846 18.4289C12.5064 18.3781 12.617 18.3037 12.71 18.21L17.71 13.21C17.801 13.1149 17.8724 13.0028 17.92 12.88C18.02 12.6365 18.02 12.3635 17.92 12.12Z"
              fill="#9999D3"
            />
          </svg>
        </router-link>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5" v-if="listCourses && listCourses.length > 0">
        <!-- no data.svg -->
        <div
          class="col-12 col-lg-4"
          style="padding: 10px"
          v-for="(item, index) in listCourses"
          :key="index"
        >
          <router-link :to="'/course/voluntary/' + item.id">
            <div
              class="card box-item"
              style="
                border-radius: 10px;
                position: relative;
                border: 1px solid #e9e9ef;
              "
            >
              <div style="position: relative">
                <img
                  :src="imageUrl + item.thumbnailsPath"
                  @error="setAltImg"
                  alt=""
                  class="w-100"
                  style="
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    object-fit: cover;
                  "
                />
                <div
                  style="
                    position: absolute;
                    left: 10px;
                    bottom: 10px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    overflow-x: hidden;
                  "
                >
                  <div
                    style="margin-right: 5px"
                    v-for="(itemHas, index) in item.hashtag"
                    :key="index"
                  >
                    <span class="badge badge-danger">{{ itemHas }}</span>
                  </div>
                </div>
              </div>
              <div class="card-body responsive-body" style="min-height: 153px">
                <div
                  class="mb-5 limit-text text-title"
                  style="font-weight: 400; color: #323563"
                >
                  {{ item.title }}
                </div>
                <Rating :value="item.rate ? item.rate : 0" :max="5" />
                <!-- <div class="text-category" style="color:#9999D3">
                  หมวดหมู่ :
                  <span v-html="renderCategory(item.categoryProfile)"></span>
                </div> -->
                <!-- <div
                  class="mb-5 limit-text text-info"
                  style="font-weight: 400;
                color: #9F9F9F!important;"
                  v-html="removeStyle(item.description)"
                ></div> -->
              </div>
              <div class="card-footer">
                <div
                  class="d-flex align-items-center flex-column mt-3 w-100"
                  v-if="item.register == true && item.progressUpdate != 100"
                >
                  <div
                    class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                  >
                    <span style="font-weight: 600"
                      >สถานะ :
                      <span v-html="renderStatus(item.statusRegister)"></span
                    ></span>
                    <span>{{ item.progressUpdate }}%</span>
                  </div>
                  <div
                    class="h-8px mx-3 w-100 rounded"
                    style="background: #e1f2ff"
                  >
                    <div
                      class="bg-progressbar rounded h-8px"
                      data-bs-toggle="tooltip"
                      :title="item.progressUpdate + '%'"
                      role="progressbar"
                      :style="'width: ' + item.progressUpdate + '%'"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div v-else style="display: flex; justify-content: center">
                  <a
                    href="#"
                    v-if="item.register == true && item.progressUpdate == 100"
                    class="btn text-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_cert"
                    @click="getCertificateId(item.id)"
                    style="
                      border-radius: 21px;
                      background: #31b67c;
                      color: #fff;
                      min-width: 235px;
                    "
                    >ดาวน์โหลดใบรับรอง</a
                  >
                  <router-link
                    v-else
                    :to="'/course/voluntary/' + item.id"
                    type="button"
                    class="btn btn-register2 text-btn"
                  >
                    ลงทะเบียน
                  </router-link>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="row mb-5" v-else>
        <img src="media/image-app/no-data.svg" alt="" style="height: 300px" />
      </div>
    </div>
    <div
      class="container mb-5 my-10"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div class="text-section" style="font-weight: 700; color: #323563">
        หลักสูตรใหม่ล่าสุด
      </div>
      <div>
        <router-link to="/course/voluntary" class="btn link"
          >ดูทั้งหมด
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M17.92 12.12C17.8724 11.9973 17.801 11.8851 17.71 11.79L12.71 6.79C12.6168 6.69676 12.5061 6.6228 12.3842 6.57234C12.2624 6.52188 12.1319 6.49591 12 6.49591C11.7337 6.49591 11.4783 6.6017 11.29 6.79C11.1968 6.88324 11.1228 6.99393 11.0723 7.11575C11.0219 7.23758 10.9959 7.36814 10.9959 7.5C10.9959 7.7663 11.1017 8.0217 11.29 8.21L14.59 11.5H7C6.73478 11.5 6.48043 11.6054 6.29289 11.7929C6.10536 11.9804 6 12.2348 6 12.5C6 12.7652 6.10536 13.0196 6.29289 13.2071C6.48043 13.3946 6.73478 13.5 7 13.5H14.59L11.29 16.79C11.1963 16.883 11.1219 16.9936 11.0711 17.1154C11.0203 17.2373 10.9942 17.368 10.9942 17.5C10.9942 17.632 11.0203 17.7627 11.0711 17.8846C11.1219 18.0064 11.1963 18.117 11.29 18.21C11.383 18.3037 11.4936 18.3781 11.6154 18.4289C11.7373 18.4797 11.868 18.5058 12 18.5058C12.132 18.5058 12.2627 18.4797 12.3846 18.4289C12.5064 18.3781 12.617 18.3037 12.71 18.21L17.71 13.21C17.801 13.1149 17.8724 13.0028 17.92 12.88C18.02 12.6365 18.02 12.3635 17.92 12.12Z"
              fill="#9999D3"
            />
          </svg>
        </router-link>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5" v-if="listCoursesNew && listCoursesNew.length > 0">
        <div
          class="col-12 col-lg-4"
          style="padding: 10px"
          v-for="(item, index) in listCoursesNew"
          :key="index"
        >
          <router-link :to="'/course/voluntary/' + item.id">
            <div
              class="card box-item"
              style="
                border-radius: 10px;
                position: relative;
                border: 1px solid #e9e9ef;
                min-height: 300px;
              "
            >
              <div style="position: relative">
                <img
                  :src="imageUrl + item.thumbnailsPath"
                  @error="setAltImg"
                  alt=""
                  class="w-100"
                  style="
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    object-fit: cover;
                  "
                />
                <div
                  style="
                    position: absolute;
                    left: 10px;
                    bottom: 10px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    overflow-x: hidden;
                  "
                >
                  <div
                    style="margin-right: 5px"
                    v-for="(itemHas, index) in item.hashtag"
                    :key="index"
                  >
                    <span class="badge badge-danger">{{ itemHas }}</span>
                  </div>
                </div>
              </div>

              <div class="card-body responsive-body" style="min-height: 153px">
                <div
                  class="mb-5 limit-text text-title"
                  style="font-weight: 400; color: #323563"
                >
                  {{ item.title }}
                </div>
                <Rating
                  :value="item.rate ? item.rate : 0"
                  :max="5"
                  :index="1"
                />
                <!-- <div class="text-category" style="color:#9999D3">
                  หมวดหมู่ :
                  <span v-html="renderCategory(item.categoryProfile)"></span>
                </div> -->
                <!-- <div
                  class="mb-5 limit-text text-info"
                  style="font-weight: 400;
                color: #9F9F9F!important;"
                  v-html="removeStyle(item.description)"
                ></div> -->
              </div>
              <div class="card-footer">
                <div
                  class="d-flex align-items-center flex-column mt-3 w-100"
                  v-if="item.register == true && item.progressUpdate != 100"
                >
                  <div
                    class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                  >
                    <span style="font-weight: 600"
                      >สถานะ :
                      <span v-html="renderStatus(item.statusRegister)"></span
                    ></span>
                    <span>{{ item.progressUpdate }}%</span>
                  </div>
                  <div
                    class="h-8px mx-3 w-100 rounded"
                    style="background: #e1f2ff"
                  >
                    <div
                      class="bg-progressbar rounded h-8px"
                      data-bs-toggle="tooltip"
                      :title="item.progressUpdate + '%'"
                      role="progressbar"
                      :style="'width: ' + item.progressUpdate + '%'"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div v-else style="display: flex; justify-content: center">
                  <a
                    href="#"
                    v-if="item.register == true && item.progressUpdate == 100"
                    class="btn text-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_cert"
                    @click="getCertificateId(item.id)"
                    style="
                      border-radius: 21px;
                      background: #31b67c;
                      color: #fff;
                      min-width: 235px;
                    "
                    >ดาวน์โหลดใบรับรอง</a
                  >
                  <router-link
                    v-else
                    :to="'/course/voluntary/' + item.id"
                    type="button"
                    class="btn btn-register2 text-btn"
                  >
                    ลงทะเบียน
                  </router-link>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="row mb-5" v-else>
        <img src="media/image-app/no-data.svg" alt="" style="height: 300px" />
      </div>
    </div>
  </div>
  <!-- course -->
  <div class="p-5" style="background: #e9e9ef">
    <div class="container my-10">
      <p class="text-header" style="font-weight: 700; text-align: center">
        ค้นหาหลักสูตรสำหรับคุณ
      </p>
      <div class="row p-100px">
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=1">
            <div class="p-2 box-item">
              <img src="media/image-app/Frame 3144.svg" alt="" class="w-100" />
              <p class="text-category my-2 text-center" style="color: #000000">
                ประชาชนทั่วไป
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=2">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3129 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                นักเรียนนักศึกษา
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=3">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3131 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                คณะทำงานด้านเทคนิค
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=4">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3132 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                เจ้าหน้าที่ปกครองส่วนท้องถิ่น
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=5">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3126 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                วิศวกร
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=6">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3130 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                ผู้พัฒนาโครงการ
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=7">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3128 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                ผู้บริหาร/เจ้าของกิจการ
              </p>
            </div>
          </router-link>
        </div>
        <div class="col-12 col-md-3 mb-3">
          <router-link to="/course/voluntary?recommend=8">
            <div class="p-2 box-item">
              <img
                src="media/image-app/Frame 3127 (1).svg"
                alt=""
                class="w-100"
              />
              <p class="text-category my-2 text-center" style="color: #000000">
                ทั้งหมด
              </p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <div
    class="p-5"
    style="
      background: #e9e9ef;
      display: flex;
      flex-direction: column;
      align-items: center;
    "
  >
    <p class="text-section" style="font-weight: 700; color: #323563">
      กำหนดการสอบของฉัน
    </p>
    <div
      v-if="listExamCenter && listExamCenter.length > 0"
      class="p-5"
      style="background: #e9e9ef"
    >
      <div class="container my-10">
        <div
          class="box-item p-0 row"
          v-for="(item, index) in listExamCenter"
          :key="index"
          style="
                border-radius: 10px;
                border: 1px solid #dbdbdb;
                background: #fff;
                padding: 10px;
                display: flex;
                flex-wrap: wrap;
              "
          @click="
            registerExamRoom(
              item.examRoomId,
              item.examRoomProfile.flgPwd,
              item.examRoomProfile.photo,
              item.examRoomProfile.examRoomCode,
              item.examRoomProfile.startDate
            )
          "
        >
          <div class="col-12 col-md-6 p-0">
            <img
              :src="imageUrl + item.examRoomProfile.examProfile.thumbnailsPath"
              @error="setAltImg"
              alt=""
              class="w-100 h-100"
              style="object-fit: cover; border-radius: 10px"
            />
          </div>
          <div class="p-5 col-12 col-md-6">
            <div
              class="mb-5 limit-text text-title"
              style="font-weight: 700; font-size: 20px; color: #323563"
            >
              {{ item.examRoomProfile.examProfile.title }}
              {{ item.examRoomProfile.syllabusProfile.name }}
            </div>
            <p class="text-category" style="font-weight: 700; color: #da595a">
              รหัส : {{ item.examRoomProfile.examProfile.examCode }}
            </p>
            <p class="text-category" style="font-weight: 700; color: #333333">
              รอบที่สอบ :
              <span
                class="text-category"
                style="font-weight: 700; color: #da595a"
                >{{ formatDateTime(item.examRoomProfile.startDate) }}
                -
                {{ formatDateTime(item.examRoomProfile.endDate) }}</span
              >
            </p>
            <p class="text-category" style="font-weight: 700; color: #333333">
              ชื่อศูนย์สอบ :
              <span
                class="text-category"
                style="font-weight: 700; color: #da595a"
                >{{ item.examRoomProfile.examCenterProfile.name }}</span
              >
            </p>
            <p class="text-category" style="color: #323563">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M11.668 10.9167H8.33464C8.11362 10.9167 7.90166 11.0045 7.74538 11.1607C7.5891 11.317 7.5013 11.529 7.5013 11.75C7.5013 11.971 7.5891 12.183 7.74538 12.3393C7.90166 12.4955 8.11362 12.5833 8.33464 12.5833H11.668C11.889 12.5833 12.1009 12.4955 12.2572 12.3393C12.4135 12.183 12.5013 11.971 12.5013 11.75C12.5013 11.529 12.4135 11.317 12.2572 11.1607C12.1009 11.0045 11.889 10.9167 11.668 10.9167ZM15.8346 5.08333H10.6013L10.3346 4.25C10.1618 3.76102 9.84109 3.33792 9.41705 3.0393C8.99301 2.74068 8.4866 2.58133 7.96797 2.58333H4.16797C3.50493 2.58333 2.86904 2.84672 2.4002 3.31556C1.93136 3.78441 1.66797 4.42029 1.66797 5.08333V15.9167C1.66797 16.5797 1.93136 17.2156 2.4002 17.6844C2.86904 18.1533 3.50493 18.4167 4.16797 18.4167H15.8346C16.4977 18.4167 17.1336 18.1533 17.6024 17.6844C18.0712 17.2156 18.3346 16.5797 18.3346 15.9167V7.58333C18.3346 6.92029 18.0712 6.28441 17.6024 5.81556C17.1336 5.34672 16.4977 5.08333 15.8346 5.08333ZM16.668 15.9167C16.668 16.1377 16.5802 16.3496 16.4239 16.5059C16.2676 16.6622 16.0556 16.75 15.8346 16.75H4.16797C3.94696 16.75 3.73499 16.6622 3.57871 16.5059C3.42243 16.3496 3.33464 16.1377 3.33464 15.9167V5.08333C3.33464 4.86232 3.42243 4.65036 3.57871 4.49408C3.73499 4.3378 3.94696 4.25 4.16797 4.25H7.96797C8.14267 4.24955 8.3131 4.30401 8.45516 4.4057C8.59722 4.50739 8.70373 4.65115 8.75964 4.81666L9.20964 6.18333C9.26554 6.34885 9.37205 6.49261 9.51411 6.5943C9.65617 6.69598 9.8266 6.75045 10.0013 6.75H15.8346C16.0556 6.75 16.2676 6.8378 16.4239 6.99408C16.5802 7.15036 16.668 7.36232 16.668 7.58333V15.9167Z"
                  fill="#9999D3"
                />
              </svg>
              หมวดหมู่ :
              {{
                item.examRoomProfile.examProfile.categoryProfile.length > 0
                  ? item.examRoomProfile.examProfile.categoryProfile[0][0].data
                  : "-"
              }}
            </p>
            <p class="text-category" style="color: #323563">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M17.6423 2.21669C17.045 2.1138 16.4401 2.06084 15.834 2.05835C13.7659 2.05666 11.741 2.64966 10.0006 3.76669C8.25576 2.66433 6.23118 2.08588 4.16731 2.10002C3.56118 2.1025 2.95631 2.15546 2.35897 2.25835C2.16331 2.29209 1.98612 2.39457 1.85932 2.54735C1.73251 2.70013 1.66442 2.89316 1.66731 3.09169V13.0917C1.66552 13.2141 1.69075 13.3355 1.74118 13.4471C1.79162 13.5586 1.86603 13.6577 1.95912 13.7373C2.05221 13.8169 2.16169 13.8749 2.27977 13.9074C2.39785 13.9398 2.52163 13.9458 2.64231 13.925C3.83649 13.7183 5.05998 13.7526 6.2407 14.0259C7.42142 14.2993 8.53549 14.8061 9.51731 15.5167L9.61731 15.575H9.70897C9.80139 15.6135 9.90052 15.6334 10.0006 15.6334C10.1008 15.6334 10.1999 15.6135 10.2923 15.575H10.384L10.484 15.5167C11.4589 14.7903 12.5698 14.267 13.7508 13.9778C14.9317 13.6887 16.1587 13.6395 17.359 13.8334C17.4796 13.8542 17.6034 13.8482 17.7215 13.8157C17.8396 13.7833 17.9491 13.7252 18.0422 13.6456C18.1353 13.5661 18.2097 13.467 18.2601 13.3554C18.3105 13.2438 18.3358 13.1225 18.334 13V3.00002C18.3253 2.81015 18.252 2.62895 18.1262 2.48647C18.0004 2.34399 17.8296 2.2488 17.6423 2.21669ZM9.16731 13.2917C7.62554 12.4806 5.90941 12.0573 4.16731 12.0584C3.89231 12.0584 3.61731 12.0584 3.33397 12.0584V3.72502C3.61152 3.70902 3.88976 3.70902 4.16731 3.72502C5.94513 3.72305 7.68415 4.24476 9.16731 5.22502V13.2917ZM16.6673 12.0917C16.384 12.0917 16.109 12.0917 15.834 12.0917C14.0919 12.0906 12.3757 12.5139 10.834 13.325V5.22502C12.3171 4.24476 14.0562 3.72305 15.834 3.72502C16.1115 3.70902 16.3898 3.70902 16.6673 3.72502V12.0917ZM17.6423 15.55C17.045 15.4471 16.4401 15.3942 15.834 15.3917C13.7659 15.39 11.741 15.983 10.0006 17.1C8.26024 15.983 6.23534 15.39 4.16731 15.3917C3.56118 15.3942 2.95631 15.4471 2.35897 15.55C2.2505 15.5672 2.14649 15.6057 2.05294 15.6633C1.95939 15.7208 1.87814 15.7963 1.81386 15.8854C1.74958 15.9744 1.70354 16.0753 1.67839 16.1822C1.65324 16.2891 1.64947 16.4 1.66731 16.5084C1.70966 16.7248 1.83605 16.9156 2.0188 17.0389C2.20155 17.1623 2.42576 17.2083 2.64231 17.1667C3.83649 16.9599 5.05998 16.9942 6.2407 17.2676C7.42142 17.5409 8.53549 18.0478 9.51731 18.7584C9.65844 18.8588 9.82739 18.9128 10.0006 18.9128C10.1739 18.9128 10.3428 18.8588 10.484 18.7584C11.4658 18.0478 12.5799 17.5409 13.7606 17.2676C14.9413 16.9942 16.1648 16.9599 17.359 17.1667C17.5755 17.2083 17.7997 17.1623 17.9825 17.0389C18.1652 16.9156 18.2916 16.7248 18.334 16.5084C18.3518 16.4 18.348 16.2891 18.3229 16.1822C18.2977 16.0753 18.2517 15.9744 18.1874 15.8854C18.1231 15.7963 18.0419 15.7208 17.9483 15.6633C17.8548 15.6057 17.7508 15.5672 17.6423 15.55Z"
                  fill="#9999D3"
                />
              </svg>
              จำนวนข้อสอบ :
              {{ item.examRoomProfile.examProfile.totalQuestion }} ข้อ
            </p>
            <p class="text-category" style="color: #323563">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M16.6654 7.94996C16.6567 7.8734 16.6399 7.79799 16.6154 7.72496V7.64996C16.5753 7.56428 16.5219 7.48551 16.457 7.41663L11.457 2.41663C11.3881 2.35181 11.3094 2.29836 11.2237 2.25829C11.1988 2.25476 11.1736 2.25476 11.1487 2.25829C11.064 2.20974 10.9706 2.17858 10.8737 2.16663H5.83203C5.16899 2.16663 4.53311 2.43002 4.06426 2.89886C3.59542 3.3677 3.33203 4.00358 3.33203 4.66663V16.3333C3.33203 16.9963 3.59542 17.6322 4.06426 18.1011C4.53311 18.5699 5.16899 18.8333 5.83203 18.8333H14.1654C14.8284 18.8333 15.4643 18.5699 15.9331 18.1011C16.402 17.6322 16.6654 16.9963 16.6654 16.3333V7.99996C16.6654 7.99996 16.6654 7.99996 16.6654 7.94996ZM11.6654 5.00829L13.8237 7.16663H12.4987C12.2777 7.16663 12.0657 7.07883 11.9094 6.92255C11.7532 6.76627 11.6654 6.55431 11.6654 6.33329V5.00829ZM14.9987 16.3333C14.9987 16.5543 14.9109 16.7663 14.7546 16.9225C14.5983 17.0788 14.3864 17.1666 14.1654 17.1666H5.83203C5.61102 17.1666 5.39906 17.0788 5.24278 16.9225C5.0865 16.7663 4.9987 16.5543 4.9987 16.3333V4.66663C4.9987 4.44561 5.0865 4.23365 5.24278 4.07737C5.39906 3.92109 5.61102 3.83329 5.83203 3.83329H9.9987V6.33329C9.9987 6.99633 10.2621 7.63222 10.7309 8.10106C11.1998 8.5699 11.8357 8.83329 12.4987 8.83329H14.9987V16.3333ZM11.907 10.7416L9.16536 13.4916L8.09036 12.4083C7.93344 12.2514 7.72062 12.1632 7.4987 12.1632C7.27678 12.1632 7.06395 12.2514 6.90703 12.4083C6.75011 12.5652 6.66195 12.778 6.66195 13C6.66195 13.2219 6.75011 13.4347 6.90703 13.5916L8.5737 15.2583C8.65117 15.3364 8.74333 15.3984 8.84488 15.4407C8.94643 15.483 9.05535 15.5048 9.16536 15.5048C9.27537 15.5048 9.3843 15.483 9.48585 15.4407C9.58739 15.3984 9.67956 15.3364 9.75703 15.2583L13.0904 11.925C13.2473 11.768 13.3354 11.5552 13.3354 11.3333C13.3354 11.1114 13.2473 10.8985 13.0904 10.7416C12.9334 10.5847 12.7206 10.4966 12.4987 10.4966C12.2768 10.4966 12.064 10.5847 11.907 10.7416Z"
                  fill="#9999D3"
                />
              </svg>
              คะแนนเต็ม :
              {{ item.examRoomProfile.examProfile.totalScore }} คะแนน
            </p>
            <button
              type="button"
              class="btn w-100"
              style="border-radius: 100px;background: var(--323563, #323563);color: #FFF;"
              @click="
                registerExamRoom(
                  item.examRoomId,
                  item.examRoomProfile.flgPwd,
                  item.examRoomProfile.photo,
                  item.examRoomProfile.examRoomCode,
                  item.examRoomProfile.startDate
                )
              "
            >
              เข้าสู่การสอบ
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <img src="media/image-app/pana.svg" alt="" class="w-100" />
      <p class="text-center">ปัจจุบันคุณยังไม่มีการสอบ</p>
    </div>
  </div>
  <div class="p-5" style="background: #ffffff;">
    <div
      class="container mb-5 my-10"
      style="display: flex;justify-content: space-between;
       align-items: center;"
    >
      <div class="text-section" style="font-weight: 700;color: #323563;">
        แบบฝึกหัด
      </div>
      <div>
        <router-link to="/exam-general" class="btn link"
          >ดูทั้งหมด
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M17.92 12.12C17.8724 11.9973 17.801 11.8851 17.71 11.79L12.71 6.79C12.6168 6.69676 12.5061 6.6228 12.3842 6.57234C12.2624 6.52188 12.1319 6.49591 12 6.49591C11.7337 6.49591 11.4783 6.6017 11.29 6.79C11.1968 6.88324 11.1228 6.99393 11.0723 7.11575C11.0219 7.23758 10.9959 7.36814 10.9959 7.5C10.9959 7.7663 11.1017 8.0217 11.29 8.21L14.59 11.5H7C6.73478 11.5 6.48043 11.6054 6.29289 11.7929C6.10536 11.9804 6 12.2348 6 12.5C6 12.7652 6.10536 13.0196 6.29289 13.2071C6.48043 13.3946 6.73478 13.5 7 13.5H14.59L11.29 16.79C11.1963 16.883 11.1219 16.9936 11.0711 17.1154C11.0203 17.2373 10.9942 17.368 10.9942 17.5C10.9942 17.632 11.0203 17.7627 11.0711 17.8846C11.1219 18.0064 11.1963 18.117 11.29 18.21C11.383 18.3037 11.4936 18.3781 11.6154 18.4289C11.7373 18.4797 11.868 18.5058 12 18.5058C12.132 18.5058 12.2627 18.4797 12.3846 18.4289C12.5064 18.3781 12.617 18.3037 12.71 18.21L17.71 13.21C17.801 13.1149 17.8724 13.0028 17.92 12.88C18.02 12.6365 18.02 12.3635 17.92 12.12Z"
              fill="#9999D3"
            />
          </svg>
        </router-link>
      </div>
    </div>
    <div class="container">
      <div class=" row mb-5" v-if="listExamPin && listExamPin.length > 0">
        <div
          class="col-12 col-lg-4"
          style="padding: 10px;"
          v-for="(item, index) in listExamPin"
          :key="index"
        >
          <div
            @click="examOpen(item.id)"
            class="card box-item"
            style="border-radius: 10px;position: relative;border: 1px solid #F2E2E1;"
          >
            <img
              :src="
                item.thumbnailsPath
                  ? imageUrl + item.thumbnailsPath
                  : 'media/image-app/no-image.svg'
              "
              @error="setAltImg"
              alt=""
              class="w-100"
              style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            object-fit: cover;"
            />
            <div class="card-body responsive-body">
              <div
                class="mb-5 limit-text text-title"
                style="font-weight: 700;
                font-size: 20px;
                color: #323563;"
              >
                {{ item.title }}
              </div>
              <p class="text-category" style="font-weight: 700;color:#DA595A">
                รหัส : {{ item.examCode }}
              </p>
              <p class="text-category" style="color:#323563">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M11.668 10.9167H8.33464C8.11362 10.9167 7.90166 11.0045 7.74538 11.1607C7.5891 11.317 7.5013 11.529 7.5013 11.75C7.5013 11.971 7.5891 12.183 7.74538 12.3393C7.90166 12.4955 8.11362 12.5833 8.33464 12.5833H11.668C11.889 12.5833 12.1009 12.4955 12.2572 12.3393C12.4135 12.183 12.5013 11.971 12.5013 11.75C12.5013 11.529 12.4135 11.317 12.2572 11.1607C12.1009 11.0045 11.889 10.9167 11.668 10.9167ZM15.8346 5.08333H10.6013L10.3346 4.25C10.1618 3.76102 9.84109 3.33792 9.41705 3.0393C8.99301 2.74068 8.4866 2.58133 7.96797 2.58333H4.16797C3.50493 2.58333 2.86904 2.84672 2.4002 3.31556C1.93136 3.78441 1.66797 4.42029 1.66797 5.08333V15.9167C1.66797 16.5797 1.93136 17.2156 2.4002 17.6844C2.86904 18.1533 3.50493 18.4167 4.16797 18.4167H15.8346C16.4977 18.4167 17.1336 18.1533 17.6024 17.6844C18.0712 17.2156 18.3346 16.5797 18.3346 15.9167V7.58333C18.3346 6.92029 18.0712 6.28441 17.6024 5.81556C17.1336 5.34672 16.4977 5.08333 15.8346 5.08333ZM16.668 15.9167C16.668 16.1377 16.5802 16.3496 16.4239 16.5059C16.2676 16.6622 16.0556 16.75 15.8346 16.75H4.16797C3.94696 16.75 3.73499 16.6622 3.57871 16.5059C3.42243 16.3496 3.33464 16.1377 3.33464 15.9167V5.08333C3.33464 4.86232 3.42243 4.65036 3.57871 4.49408C3.73499 4.3378 3.94696 4.25 4.16797 4.25H7.96797C8.14267 4.24955 8.3131 4.30401 8.45516 4.4057C8.59722 4.50739 8.70373 4.65115 8.75964 4.81666L9.20964 6.18333C9.26554 6.34885 9.37205 6.49261 9.51411 6.5943C9.65617 6.69598 9.8266 6.75045 10.0013 6.75H15.8346C16.0556 6.75 16.2676 6.8378 16.4239 6.99408C16.5802 7.15036 16.668 7.36232 16.668 7.58333V15.9167Z"
                    fill="#9999D3"
                  />
                </svg>
                หมวดหมู่ :
                {{
                  item.categoryProfile.length > 0
                    ? item.categoryProfile[0][0].data
                    : "-"
                }}
              </p>
              <p class="text-category" style="color:#323563">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M17.6423 2.21669C17.045 2.1138 16.4401 2.06084 15.834 2.05835C13.7659 2.05666 11.741 2.64966 10.0006 3.76669C8.25576 2.66433 6.23118 2.08588 4.16731 2.10002C3.56118 2.1025 2.95631 2.15546 2.35897 2.25835C2.16331 2.29209 1.98612 2.39457 1.85932 2.54735C1.73251 2.70013 1.66442 2.89316 1.66731 3.09169V13.0917C1.66552 13.2141 1.69075 13.3355 1.74118 13.4471C1.79162 13.5586 1.86603 13.6577 1.95912 13.7373C2.05221 13.8169 2.16169 13.8749 2.27977 13.9074C2.39785 13.9398 2.52163 13.9458 2.64231 13.925C3.83649 13.7183 5.05998 13.7526 6.2407 14.0259C7.42142 14.2993 8.53549 14.8061 9.51731 15.5167L9.61731 15.575H9.70897C9.80139 15.6135 9.90052 15.6334 10.0006 15.6334C10.1008 15.6334 10.1999 15.6135 10.2923 15.575H10.384L10.484 15.5167C11.4589 14.7903 12.5698 14.267 13.7508 13.9778C14.9317 13.6887 16.1587 13.6395 17.359 13.8334C17.4796 13.8542 17.6034 13.8482 17.7215 13.8157C17.8396 13.7833 17.9491 13.7252 18.0422 13.6456C18.1353 13.5661 18.2097 13.467 18.2601 13.3554C18.3105 13.2438 18.3358 13.1225 18.334 13V3.00002C18.3253 2.81015 18.252 2.62895 18.1262 2.48647C18.0004 2.34399 17.8296 2.2488 17.6423 2.21669ZM9.16731 13.2917C7.62554 12.4806 5.90941 12.0573 4.16731 12.0584C3.89231 12.0584 3.61731 12.0584 3.33397 12.0584V3.72502C3.61152 3.70902 3.88976 3.70902 4.16731 3.72502C5.94513 3.72305 7.68415 4.24476 9.16731 5.22502V13.2917ZM16.6673 12.0917C16.384 12.0917 16.109 12.0917 15.834 12.0917C14.0919 12.0906 12.3757 12.5139 10.834 13.325V5.22502C12.3171 4.24476 14.0562 3.72305 15.834 3.72502C16.1115 3.70902 16.3898 3.70902 16.6673 3.72502V12.0917ZM17.6423 15.55C17.045 15.4471 16.4401 15.3942 15.834 15.3917C13.7659 15.39 11.741 15.983 10.0006 17.1C8.26024 15.983 6.23534 15.39 4.16731 15.3917C3.56118 15.3942 2.95631 15.4471 2.35897 15.55C2.2505 15.5672 2.14649 15.6057 2.05294 15.6633C1.95939 15.7208 1.87814 15.7963 1.81386 15.8854C1.74958 15.9744 1.70354 16.0753 1.67839 16.1822C1.65324 16.2891 1.64947 16.4 1.66731 16.5084C1.70966 16.7248 1.83605 16.9156 2.0188 17.0389C2.20155 17.1623 2.42576 17.2083 2.64231 17.1667C3.83649 16.9599 5.05998 16.9942 6.2407 17.2676C7.42142 17.5409 8.53549 18.0478 9.51731 18.7584C9.65844 18.8588 9.82739 18.9128 10.0006 18.9128C10.1739 18.9128 10.3428 18.8588 10.484 18.7584C11.4658 18.0478 12.5799 17.5409 13.7606 17.2676C14.9413 16.9942 16.1648 16.9599 17.359 17.1667C17.5755 17.2083 17.7997 17.1623 17.9825 17.0389C18.1652 16.9156 18.2916 16.7248 18.334 16.5084C18.3518 16.4 18.348 16.2891 18.3229 16.1822C18.2977 16.0753 18.2517 15.9744 18.1874 15.8854C18.1231 15.7963 18.0419 15.7208 17.9483 15.6633C17.8548 15.6057 17.7508 15.5672 17.6423 15.55Z"
                    fill="#9999D3"
                  />
                </svg>
                จำนวนข้อสอบ : {{ item.totalQuestion }} ข้อ
              </p>
              <p class="text-category" style="color:#323563">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M16.6654 7.94996C16.6567 7.8734 16.6399 7.79799 16.6154 7.72496V7.64996C16.5753 7.56428 16.5219 7.48551 16.457 7.41663L11.457 2.41663C11.3881 2.35181 11.3094 2.29836 11.2237 2.25829C11.1988 2.25476 11.1736 2.25476 11.1487 2.25829C11.064 2.20974 10.9706 2.17858 10.8737 2.16663H5.83203C5.16899 2.16663 4.53311 2.43002 4.06426 2.89886C3.59542 3.3677 3.33203 4.00358 3.33203 4.66663V16.3333C3.33203 16.9963 3.59542 17.6322 4.06426 18.1011C4.53311 18.5699 5.16899 18.8333 5.83203 18.8333H14.1654C14.8284 18.8333 15.4643 18.5699 15.9331 18.1011C16.402 17.6322 16.6654 16.9963 16.6654 16.3333V7.99996C16.6654 7.99996 16.6654 7.99996 16.6654 7.94996ZM11.6654 5.00829L13.8237 7.16663H12.4987C12.2777 7.16663 12.0657 7.07883 11.9094 6.92255C11.7532 6.76627 11.6654 6.55431 11.6654 6.33329V5.00829ZM14.9987 16.3333C14.9987 16.5543 14.9109 16.7663 14.7546 16.9225C14.5983 17.0788 14.3864 17.1666 14.1654 17.1666H5.83203C5.61102 17.1666 5.39906 17.0788 5.24278 16.9225C5.0865 16.7663 4.9987 16.5543 4.9987 16.3333V4.66663C4.9987 4.44561 5.0865 4.23365 5.24278 4.07737C5.39906 3.92109 5.61102 3.83329 5.83203 3.83329H9.9987V6.33329C9.9987 6.99633 10.2621 7.63222 10.7309 8.10106C11.1998 8.5699 11.8357 8.83329 12.4987 8.83329H14.9987V16.3333ZM11.907 10.7416L9.16536 13.4916L8.09036 12.4083C7.93344 12.2514 7.72062 12.1632 7.4987 12.1632C7.27678 12.1632 7.06395 12.2514 6.90703 12.4083C6.75011 12.5652 6.66195 12.778 6.66195 13C6.66195 13.2219 6.75011 13.4347 6.90703 13.5916L8.5737 15.2583C8.65117 15.3364 8.74333 15.3984 8.84488 15.4407C8.94643 15.483 9.05535 15.5048 9.16536 15.5048C9.27537 15.5048 9.3843 15.483 9.48585 15.4407C9.58739 15.3984 9.67956 15.3364 9.75703 15.2583L13.0904 11.925C13.2473 11.768 13.3354 11.5552 13.3354 11.3333C13.3354 11.1114 13.2473 10.8985 13.0904 10.7416C12.9334 10.5847 12.7206 10.4966 12.4987 10.4966C12.2768 10.4966 12.064 10.5847 11.907 10.7416Z"
                    fill="#9999D3"
                  />
                </svg>
                คะแนนเต็ม : {{ item.totalScore }} คะแนน
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class=" row mb-5" v-else>
        <img src="media/image-app/no data.svg" alt="" style="height:300px" />
      </div>
    </div>
  </div>
  <div class="p-5 container my-10">
    <div
      class="container mb-5"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div
        class="text-section"
        style="font-weight: 700
          color: #323563;"
      >
        ข่าวสารและบทความ
      </div>
      <div>
        <router-link to="/blogs" class="btn link"
          >ดูทั้งหมด
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M17.92 12.12C17.8724 11.9973 17.801 11.8851 17.71 11.79L12.71 6.79C12.6168 6.69676 12.5061 6.6228 12.3842 6.57234C12.2624 6.52188 12.1319 6.49591 12 6.49591C11.7337 6.49591 11.4783 6.6017 11.29 6.79C11.1968 6.88324 11.1228 6.99393 11.0723 7.11575C11.0219 7.23758 10.9959 7.36814 10.9959 7.5C10.9959 7.7663 11.1017 8.0217 11.29 8.21L14.59 11.5H7C6.73478 11.5 6.48043 11.6054 6.29289 11.7929C6.10536 11.9804 6 12.2348 6 12.5C6 12.7652 6.10536 13.0196 6.29289 13.2071C6.48043 13.3946 6.73478 13.5 7 13.5H14.59L11.29 16.79C11.1963 16.883 11.1219 16.9936 11.0711 17.1154C11.0203 17.2373 10.9942 17.368 10.9942 17.5C10.9942 17.632 11.0203 17.7627 11.0711 17.8846C11.1219 18.0064 11.1963 18.117 11.29 18.21C11.383 18.3037 11.4936 18.3781 11.6154 18.4289C11.7373 18.4797 11.868 18.5058 12 18.5058C12.132 18.5058 12.2627 18.4797 12.3846 18.4289C12.5064 18.3781 12.617 18.3037 12.71 18.21L17.71 13.21C17.801 13.1149 17.8724 13.0028 17.92 12.88C18.02 12.6365 18.02 12.3635 17.92 12.12Z"
              fill="#9999D3"
            />
          </svg>
        </router-link>
      </div>
    </div>
    <div class="container mb-5">
      <div
        v-for="(item, index) in listBlogs"
        :key="index"
        class="box-item mb-5 p-3"
      >
        <router-link :to="'/blogs/' + item.id">
          <div class="row">
            <div class="col-12 col-lg-4">
              <img
                :src="imageUrl + item.thumbnailsPath"
                @error="setAltImg"
                alt=""
                class="w-100"
                style="
                  object-fit: cover;
                  border: 0.886486px solid #dcdcdc;
                  border-radius: 10px;
                "
              />
            </div>
            <div class="col-12 col-lg-8" style="overflow-wrap: anywhere">
              <p class="text-category" style="font-weight: 400; color: #9999d3">
                {{ formatDate(item.createDate) }} |
                {{
                  item.categoryProfile.length > 0
                    ? item.categoryProfile[0][0].data
                    : ""
                }},
              </p>
              <p class="text-title" style="font-weight: 400; color: #323563">
                {{ item.title }}
              </p>
              <p
                class="limit-text4 text-category"
                style="font-weight: 400; color: #9f9f9f !important"
                v-html="removeStyle(item.description)"
              ></p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
  <div class="p-5" style="background: #e9e9ef">
    <div class="container my-10">
      <div
        class="section-header mb-5"
        style="font-weight: 700;
        font-size: 3vh
          color: #323563;"
      >
        เว็บไซต์อนุรักษ์พลังงาน
      </div>
      <div class="row my-10">
        <div class="col-12 col-lg-3 mb-3">
          <div
            class="box"
            style="
              border-radius: 10px;
              padding: 10px;
              height: 150px;
              position: relative;
            "
          >
            <p
              style="
                line-height: 30px;
                color: #da595a;
                font-size: 2.5vh;
                font-weight: 600;
              "
            >
              กระทรวงพลังงาน
            </p>
            <p style="color: #323563">Ministry of Energy</p>
            <a
              href="https://www.energy.go.th"
              target="_blank"
              class="hover-btn"
              style="position: absolute; bottom: 10px"
            >
              <img
                class="img-icon"
                src="media/image-app/right arrow circle.svg"
                alt=""
                style="height: 25px"
              />
              <span class="btn-text px-2">www.energy.go.th</span>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div
            class="box"
            style="
              border-radius: 10px;
              padding: 10px;
              height: 150px;
              position: relative;
            "
          >
            <p
              style="
                line-height: 30px;
                color: #da595a;
                font-size: 2.5vh;
                font-weight: 600;
              "
            >
              กรมพัฒนาพลังงานทดแทน และอนุรักษ์พลังงาน
            </p>
            <p style="color: #323563">กระทรวงพลังงาน</p>
            <a
              href="https://www.dede.go.th"
              target="_blank"
              class="hover-btn"
              style="position: absolute; bottom: 10px"
            >
              <img
                class="img-icon"
                src="media/image-app/right arrow circle.svg"
                style="height: 25px"
                alt=""
              />
              <span class="btn-text px-2">www.dede.go.th</span>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div
            class="box"
            style="
              border-radius: 10px;
              padding: 10px;
              height: 150px;
              position: relative;
            "
          >
            <p
              style="
                line-height: 30px;
                color: #da595a;
                font-size: 2.5vh;
                font-weight: 600;
              "
            >
              กรมเชื้อเพลิงธรรมชาติ
            </p>
            <p style="color: #323563">กระทรวงพลังงาน</p>
            <a
              href="https://www.dmf.go.th"
              target="_blank"
              class="hover-btn"
              style="position: absolute; bottom: 10px"
            >
              <img
                class="img-icon"
                src="media/image-app/right arrow circle.svg"
                style="height: 25px"
                alt=""
              />
              <span class="btn-text px-2">www.dmf.go.th</span>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div
            class="box"
            style="
              border-radius: 10px;
              padding: 10px;
              height: 150px;
              position: relative;
            "
          >
            <p
              style="
                line-height: 30px;
                color: #da595a;
                font-size: 2.5vh;
                font-weight: 600;
              "
            >
              กรมธุรกิจพลังงาน
            </p>
            <p style="color: #323563">กระทรวงพลังงาน</p>
            <a
              href="https://www.doeb.go.th"
              target="_blank"
              class="hover-btn"
              style="position: absolute; bottom: 10px"
            >
              <img
                class="img-icon"
                src="media/image-app/right arrow circle.svg"
                style="height: 25px"
                alt=""
              />
              <span class="btn-text px-2">www.doeb.go.th</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="modal fade" tabindex="-1" id="kt_modal_cert">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-body">
          <div style="text-align: center" v-if="listCertificate">
            <div>
              <img src="media/image-app/image 10.svg" alt="" class="w-50" />
            </div>
            <div>
              <p class="text-title my-10">ขอมอบใบรับรองนี้ให้แก่</p>
              <p class="text-title my-20">
                {{ listCertificate.authorProfile.prefix }}
                {{ listCertificate.authorProfile.firstName }}
                {{ listCertificate.authorProfile.lastName }}
              </p>
              <p class="text-title my-10">
                เพื่อแสดงว่าได้ผ่านการฝึกอบรมออนไลน์หลักสูตร
              </p>
              <p class="text-title my-10">
                {{ listCertificate.courseProfile.title }}
              </p>
              <p class="text-title my-10">
                ให้ไว้ ณ วันที่
                {{ formatDate(listCertificate.certApproveDate) }}
              </p>
              <p class="text-title" style="margin-top: 15vh">
                (นางมัณลิกา สมพรานนท์)
              </p>
              <p class="text-title my-10">
                ผู้อำนวยการกองพัฒนาทรัพยากรบุคคลด้านพลังงาน ปฏิบัติราชการแทน
              </p>
              <p class="text-title my-10">
                อธิบดีกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
            style="border-radius: 21px"
          >
            ปิด
          </button>
          <button
            type="button"
            class="btn"
            style="border-radius: 21px; background: #31b67c; color: #fff"
            @click="downloadCertificate"
          >
            ดาวน์โหลดใบรับรอง
          </button>
        </div>
      </div>
    </div>
  </div> -->
  <div class="modal fade" id="kt_modal_password" ref="modalPassword">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <h3 class="modal-title" style="text-align: center">
            กรุณากรอกรหัสห้องสอบ
          </h3>
          <p class="text-center">รหัสห้องสอบได้จากเจ้าหน้าที่ดูแลศูนย์สอบ</p>
        </div>
        <div class="modal-body text-center">
          <div style="position: relative;">
            <input
              class="form-control form-control-lg"
              :type="passwordFieldType"
              v-model="roomPwd"
            />
            <button
              style="position: absolute;top: 0;right: 5px;"
              type="button"
              class="btn"
              @click="switchVisibility"
            >
              <i class="fa fa-eye"></i>
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
            style="border-radius: 21px"
          >
            ยกเลิก
          </button>
          <button
            type="button"
            class="btn"
            style="
              color: var(--ffffff, #fff);
              border-radius: 29px;
              background: var(--323563, #323563);
            "
            @click="submitPassword"
          >
            ตกลง
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Rating from "./Rating.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
// import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { Modal } from "bootstrap";
import { hideModal, showModal } from "@/core/helpers/dom";
import axios from "axios";
import router from "@/router";
import { useRoute, useRouter } from "vue-router";
const video = ref();
const canvas = ref();
const captures: any = ref([]);
const isCameraOpen = ref(false);
const listBlogs = ref();
const listCourses = ref();
const listSyllabuses = ref();
const listCoursesNew = ref();
const listCertificate = ref();
const listExamCenter = ref();
const listExamPin = ref();
const roomcode = ref();
const roomPwd = ref();
const flgPhoto = ref();
const modalPassword = ref<null | HTMLElement>(null);
export default defineComponent({
  name: "home",
  components: {
    Rating,
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      passwordFieldType: "password",
      sizeStatistic: null,
    };
  },
  setup() {
    /* eslint-disable */
    const route = useRoute();
    const router = useRouter();
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      router.go(0);
    }
    onMounted(async () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getNews" +
            "?sizeContents=3&page=0&orderBy=1&sort=1&enable=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          }
        )
        .then(({ data }) => {
          // console.log("getNews");
          // console.log(data.data.content);
          listBlogs.value = data.data.content;
        })
        .catch(({ error }) => {
          // console.log(error);
        });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourse" +
            "?sizeContents=3&page=0&orderBy=2&sort=1&enable=1&flgGeneral=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          }
        )
        .then(({ data }) => {
          // console.log("getCourse");
          // console.log(data.data.content);
          listCourses.value = data.data.content;
        })
        .catch(({ error }) => {
          // console.log(error);
        });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourse" +
            "?sizeContents=3&page=0&orderBy=2&sort=3&enable=1&flgGeneral=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          }
        )
        .then(({ data }) => {
          // console.log("listCoursesNew");
          // console.log(data);
          listCoursesNew.value = data.data.content;
        })
        .catch(({ error }) => {
          // console.log(error);
        });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getSyllabus?&sizeContents=4&page=0&orderBy=1&sort=1&enable=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          }
        )
        .then(({ data }) => {
          // console.log("listSyllabuses");
          // console.log(data.data.content);
          listSyllabuses.value = data.data.content;
        })
        .catch(({ error }) => {
          // console.log(error);
        });
      if (localStorage.getItem("id_token") != null) {
        getExamRoomRegister();
      }
      await getExam();
    });
    const getExam = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExam" +
            "?sizeContents=3&page=0&orderBy=2&sort=1&enable=1&examType=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          }
        )
        .then(({ data }) => {
          // console.log("getExamPin");
          // console.log(data.data.content);
          listExamPin.value = data.data.content;
        })
        .catch(({ error }) => {
          // localStorage.clear();
          router.push({ name: "sign-in" });
        });
    };
    const registerSyllabus = (id, register, status) => {
      if (status == "true") {
        router.push({ name: "mandatory-list", params: { id: id } });
      } else {
        Swal.fire({
          title: "เงื่อนไขการผ่านหลักสูตร",
          html:
            "ระบบจะจับเวลาเพื่อนับถอยหลังการเรียน<br>เมื่อเรียนจบต้องกรอกข้อมูลเพื่อยืนยันตัวตนก่อนการจองห้องสอบ<br>เพื่อขอใบรับรอง",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#323563",
          cancelButtonColor: "#d33",
          confirmButtonText: "ลงทะเบียน",
          allowOutsideClick: false,
          cancelButtonText: "ยกเลิก",
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (localStorage.getItem("id_token")) {
              if (register == true) {
                router.push({ name: "mandatory-list", params: { id: id } });
              } else {
                const formData = new FormData();
                formData.append("syllabusId", id);
                await axios
                  .post(
                    process.env.VUE_APP_API_URL + "/registerSyllabus",
                    formData,
                    {
                      headers: {
                        token: localStorage.getItem("id_token")
                          ? localStorage.getItem("id_token")
                          : localStorage.getItem("tokenGuest"),
                      },
                    }
                  )
                  .then(({ data }) => {
                    router.push({ name: "mandatory-list", params: { id: id } });
                  })
                  .catch(({ error }) => {
                    // console.log(error);
                  });
              }
            } else {
              router.push({ name: "sign-in" });
            }
          }
        });
      }
    };
    const getCertificateId = async (id) => {
      const certificate = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          id +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: {
            token: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : localStorage.getItem("tokenGuest"),
          },
        }
      );
      // console.log(certificate.data.data.content[0]);
      listCertificate.value = certificate.data.data.content[0];
      downloadCertificate();
    };
    const downloadCertificate = async () => {
      const director = await axios.get(
        process.env.VUE_APP_API_URL + "/getDirector",
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        }
      );
      // console.log(
      //   director.data.data.firstName + " " + director.data.data.lastName
      // );
      let date: String =
        new Date(listCertificate.value.certApproveDate).toLocaleDateString(
          "th-TH",
          {
            year: "numeric",
            month: "long",
            day: "numeric",
          }
        ) + "";
      const url =
        process.env.VUE_APP_REPORT_URL +
        "&title=" +
        listCertificate.value.authorProfile.prefix +
        "&course=" +
        listCertificate.value.courseProfile.title +
        "&firstname=" +
        listCertificate.value.authorProfile.firstName +
        "&lastname=" +
        listCertificate.value.authorProfile.lastName +
        "&date=" +
        arabic_to_thai(date) +
        "&license=" +
        process.env.VUE_APP_IMG_URL +
        director.data.data.signature +
        "&licenseName=" +
        director.data.data.firstName +
        " " +
        director.data.data.lastName +
        "&position=" +
        director.data.data.position;
      window.open(url.replace("/fileName", "/cert_dede2.pdf"), "_blank");
    };
    const getExamRoomRegister = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExamRoomRegister" +
            "?sizeContents=1&page=0&status=0,1&isDetail=true&userId=" +
            localStorage.getItem("u_id") +
            "&startDateEnter=",
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          }
        )
        .then(({ data }) => {
          // console.log("getExamRoomRegister");
          let list: any = [];
          for (const loopData of data.data.content) {
            if (loopData.startTestDate != null) {
              if (
                new Date(loopData.startTestDate).getTime() >
                new Date().setHours(0, 0, 0)
              ) {
                list.push(loopData);
              }
            } else {
              if (
                new Date(loopData.examRoomProfile.endDate).getTime() >
                new Date().setHours(0, 0, 0)
              ) {
                list.push(loopData);
              }
            }
          }
          listExamCenter.value = list;
        })
        .catch(({ error }) => {
          // console.log(error);
          // localStorage.clear();
          router.push({ name: "sign-in" });
        });
    };
    const registerExamRoom = async (
      id,
      flgPwd,
      photo,
      examRoomCode,
      startDate
    ) => {
      if (startDate && new Date().getTime() >= new Date(startDate).getTime()) {
        roomcode.value = examRoomCode;
        flgPhoto.value = photo;
        if (flgPwd && photo) {
          const myModal = Modal.getInstance(modalPassword.value!);
          myModal?.show();
        } else if (flgPwd) {
          const myModal = Modal.getInstance(modalPassword.value!);
          myModal?.show();
        } else if (photo) {
          router.push({
            name: "verify",
            params: { examRoomCode: examRoomCode },
          });
        } else {
          const formData = new FormData();
          formData.append("examRoomCode", examRoomCode + "");
          await axios
            .post(
              process.env.VUE_APP_API_URL + "/enterExamRoomRegister",
              formData,
              {
                headers: {
                  token: localStorage.getItem("id_token"),
                },
              }
            )
            .then((response) => {
              if (response.data.code == 200) {
                router.push({
                  name: "exam-detail",
                  params: { id: response.data.data.examRoomId },
                });
              } else {
                Swal.fire({
                  text: response.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "ลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      } else {
        Swal.fire({
          text: "ยังไม่ถึงเวลาเข้าสอบ",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    };
    const submitPassword = async () => {
      hideModal(modalPassword.value);
      const formData = new FormData();
      formData.append("examRoomCode", roomcode!.value + "");
      formData.append("examRoomPwd", roomPwd!.value + "");
      await axios
        .post(
          process.env.VUE_APP_API_URL + "/checkExamRoomRegister",
          formData,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          }
        )
        .then(async (response) => {
          if (response.data.code == 200) {
            if (flgPhoto.value == true) {
              router.push({
                name: "verify",
                params: { examRoomCode: roomcode.value },
              });
            } else {
              enterRoom();
            }
          } else {
            Swal.fire({
              text: response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const enterRoom = async () => {
      const formData = new FormData();
      formData.append("examRoomCode", roomcode!.value + "");
      formData.append("examRoomPwd", roomPwd!.value + "");
      await axios
        .post(
          process.env.VUE_APP_API_URL + "/enterExamRoomRegister",
          formData,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          }
        )
        .then((response) => {
          // console.log(response);
          if (response.data.code == 200) {
            router.push({
              name: "exam-detail",
              params: { id: response.data.data.examRoomId },
            });
          } else {
            Swal.fire({
              text: response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const arabic_to_thai = (text) => {
    let data = text.replaceAll("1", "๑").replaceAll("2", "๒").replaceAll("3", "๓").replaceAll("4", "๔").replaceAll("5", "๕").replaceAll("6", "๖").replaceAll("7", "๗").replaceAll("8", "๘").replaceAll("9", "๙").replaceAll("0", "๐")
    return data
}
    return {
      video,
      canvas,
      captures,
      isCameraOpen,
      listBlogs,
      listCourses,
      listSyllabuses,
      registerSyllabus,
      listCoursesNew,
      listCertificate,
      getCertificateId,
      downloadCertificate,
      getExamRoomRegister,
      listExamCenter,
      registerExamRoom,
      getExam,
      listExamPin,
      modalPassword,
      showModal,
      hideModal,
      submitPassword,
      enterRoom,
      roomcode,
      roomPwd,
      flgPhoto,
      arabic_to_thai
    };
  },
  async mounted() {
    const modal_score = document.getElementById("kt_modal_password")!;
    const modal = new Modal(modal_score);
    const size = await axios.get(
      process.env.VUE_APP_API_URL + "/getSizeStatistic",
      {
        headers: {
          token: localStorage.getItem("id_token")
            ? localStorage.getItem("id_token")
            : localStorage.getItem("tokenGuest"),
        },
      }
    );
    // console.log("getSizeStatistic");
    // console.log(size.data.data);
    this.sizeStatistic = size.data.data;
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    removeStyle(html) {
      const regex = /(style=".+?")/gm;
      const str = html;
      const subst = ``;
      const result = str.replace(regex, subst);
      return result;
    },
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    toggleCamera() {
      if (isCameraOpen.value) {
        isCameraOpen.value = false;
        this.stopCameraStream();
      } else {
        isCameraOpen.value = true;
        this.createCameraElement();
      }
      //  createCameraElement();
      //  stopCameraStream();
    },
    createCameraElement() {
      video.value = this.$refs.video;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: false })
          .then((stream) => {
            video.value.srcObject = stream;
            video.value.play();
          });
      }
    },
    stopCameraStream() {
      video.value = this.$refs.video;
      video.value = video.value.srcObject.getTracks();
      video.value.forEach((track) => {
        track.stop();
      });
    },
    capture() {
      /* eslint-disable */
      canvas.value = this.$refs.canvas;
      var context: any = canvas.value
        .getContext("2d")
        .drawImage(this.video, 0, 0, 640, 480);
      captures.value.push(canvas.value.toDataURL("image/png"));
      // this.captures.push(canvas.value.toDataURL("image/png"));
      /* eslint-disable */
    },
    renderCategory(list) {
      let data: any = [];
      for (const looplist of list) {
        data.push(looplist[0].data);
      }
      if (data.length > 0) {
        return data.join(",");
      } else {
        return "-";
      }
    },
    renderStatus(status) {
      if (status == 1 || status == 2) {
        return "<span style='color:#9999D3'>เรียนต่อ</span>";
      } else if (status == 3) {
        return "<span style='color:#31B67C'>เรียนจบ</span>";
      } else if (status == 4) {
        return "<span style='color:#FF7786'>ไม่ผ่านหลักสูตร</span>";
      } else if (status == 5) {
        return "<span style='color:#F2A17D'>หมดเวลาเรียน</span>";
      } else {
        return "-";
      }
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    examOpen(id) {
      if (localStorage.getItem("id_token") != null) {
        this.$router.push({ name: "exam-general-detail", params: { id: id } });
      } else {
        this.$router.push({ name: "sign-in" });
      }
    },

    abbreviateNumber(number) {
      var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
      // what tier? (determines SI symbol)
      var tier = (Math.log10(Math.abs(number)) / 3) | 0;
      // if zero, we don't need a suffix
      if (tier == 0) return number;

      // get suffix and determine scale
      var suffix = SI_SYMBOL[tier];
      var scale = Math.pow(10, tier * 3);

      // scale the number
      var scaled = number / scale;

      // format number and add suffix
      return scaled.toFixed(1) + suffix;
    },
  },
});
</script>
<style scoped>
.bg-progressbar {
  background: #55acee;
}
.hover-btn {
  font-weight: 400;
  line-height: 18px;
  color: #da595a;
}
/* img-icon */
.hover-btn:hover .btn-text {
  display: inline;
}
.hover-btn:hover .img-icon {
  display: none;
}
.hover-btn2 {
  font-weight: 400;
  line-height: 18px;
  color: #9999d3;
}
/* img-icon */

.hover-btn2:hover .btn-text2 {
  display: inline;
}
.hover-btn2:hover .img-icon2 {
  display: none;
}
.news:hover {
  border: 1px solid #da595a;
  /* filter: drop-shadow(0px 0px 12px rgba(50, 53, 99, 0.25)); */
  border-radius: 10px;
  padding: 10px;
}

.item-hover:hover {
  border: 1px solid #da595a;
}
.p-100px {
  padding: auto;
}
@media (min-width: 800px) {
  .p-100px {
    padding-left: 100px;
    padding-right: 100px;
  }
}
</style>
